module.exports = __webpack_public_path__ + "img/flowers-8219261_1280.ad9728da.png";